import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Lisa lemmikuks

  <span style="color:#85c1dc;">**FI:**</span>
  Lisää suosikkeihin

  <span style="color:#85c1dc;">**RU:**</span>
  Добавить в избранное
*/
/* @__NO_SIDE_EFFECTS__ */
const m680 = msg(
  mf`Lisa lemmikuks`,
  mf`Lisää suosikkeihin`,
  mf`Добавить в избранное`,
)

export { m680 as 'w.global.product.favourite' }